import { render } from "./Modal2.vue?vue&type=template&id=b4ebf96c&scoped=true"
import script from "./Modal2.vue?vue&type=script&lang=js"
export * from "./Modal2.vue?vue&type=script&lang=js"

import "./Modal2.vue?vue&type=style&index=0&id=b4ebf96c&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4ebf96c"]])

export default __exports__